// Keep public and signed previews at the same CDN-cacheable sizes.
export const PHOTO_PREVIEW_TRANSFORMS = {
  thumb: { width: 96, height: 96, resize: 'cover', quality: 70 },
  card: { width: 640, height: 480, resize: 'contain', quality: 75 },
};
